const getters = {
    token: state => state.user.token,
    roles: state => state.user.permissionList,
    permission_routes: state => state.permission.routes,
    user_info: state => state.user.userInfo,
  }
  
  export default getters